import { Grid, Stack } from '@mui/material';
import { RoadcareLogoBlue } from '../logo/RoadcareLogoBlue';

export const Header = () => (
    <Stack direction="row" sx={{ justifyContent: 'space-between', my: 3 }}>
        <Grid container>
            <Grid item xs={3} />
            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <RoadcareLogoBlue height="44px" />
            </Grid>
            <Grid item xs={3} />
        </Grid>
    </Stack>
);
